// extracted by mini-css-extract-plugin
export default {"contain":"solution_contain__aQ2oC","topbar":"solution_topbar__uE7Lu","item":"solution_item__DLD6a","active":"solution_active__EltCg","content":"solution_content__RX78T"};